// import React, { useEffect, useMemo, useState } from "react";
// import "./ProjectsPage.css";
// import "../components/Projects.css";
// import "../components/Hero.css";
// import "../components/ButtonOverrides.css";
// import Footer from "../components/Footer";
// import { Link, useSearchParams } from "react-router-dom";
// import { projects } from "../data/projects";

// import FilterDrawer, { LocFilter } from "../components/FilterDrawer";
// import QuickFilterDrawer from "../components/QuickFilterDrawer";

// // Import or define heroBg image
// const heroBg = `${process.env.PUBLIC_URL}/images/Hero2.jpeg`;

// // ==== helpers ====
// const normalizeTypes = (t: any): string[] => (!t ? [] : Array.isArray(t) ? t : [t]);
// const isInsideLebanon = (location?: string) =>
//   typeof location === "string" && /(^|[\s,|.-])lebanon([\s,|.-]|$)/i.test(location);

// const ProjectsPage: React.FC = () => {
//   const [searchParams] = useSearchParams();
//   // Read initial filter from URL
//   const initialLoc = (searchParams.get("loc") as LocFilter) || "all";
//   const initialTypes = (searchParams.get("types") || "")
//     .split(",")
//     .filter(Boolean);

//   // Use these as initial state
//   const [locFilter, setLocFilter] = useState<LocFilter>(initialLoc);
//   const [typeFilter, setTypeFilter] = useState<string[]>(initialTypes);

//   // drawer state
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   // pagination
//   const [visibleCount, setVisibleCount] = useState(9);

//   // build distinct list of all types from data
//   const allTypes = useMemo(() => {
//     const all = projects.flatMap((p: any) => normalizeTypes(p.type));
//     return Array.from(new Set(all)).sort((a, b) => a.localeCompare(b));
//   }, []);

//   // apply filters
//   const filteredProjects = useMemo(() => {
//     return projects.filter((p: any) => {
//       if (locFilter === "inside" && !isInsideLebanon(p.location)) return false;
//       if (locFilter === "outside" && isInsideLebanon(p.location)) return false;
//       if (typeFilter.length === 0) return true;
//       const t = normalizeTypes(p.type).map((s) => s.toLowerCase());
//       return typeFilter.some((sel) => t.includes(sel.toLowerCase()));
//     });
//   }, [locFilter, typeFilter]);

//   // reset pagination when filters change
//   useEffect(() => setVisibleCount(9), [locFilter, typeFilter]);

//   const handleLoadMore = () =>
//     setVisibleCount((prev) => Math.min(prev + 9, filteredProjects.length));

//   return (
//     <>
//       {/* Hero */}
//       <div
//         className="projects-hero"
//         style={{
//           backgroundImage: `url(${heroBg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <div className="projects-hero-overlay">
//           <p className="projects-tagline">WE STAND FOR</p>
//           <h1 className="projects-title">Having an idea. Creating spaces.</h1>
//         </div>
//       </div>

//       {/* Toolbar: drawer toggle + count */}
//       <div
//         className="projects-toolbar"
//         style={{
//           maxWidth: 1280,
//           margin: "16px auto 8px",
//           display: "flex",
//           alignItems: "center",
//           gap: 12,
//           padding: "0 8px",
//         }}
//       >
//      <button
//   id="open-filter"
//   onClick={() => setDrawerOpen(true)}
//   style={{
//     padding: "10px 16px",
//     borderRadius: 10,
//     fontWeight: 700,
//     cursor: "pointer",
//   }}
// >
//   ☰ Filter
// </button>

//         <div style={{ opacity: 0.7 }}>
//           Showing <b>{filteredProjects.length}</b> of <b>{projects.length}</b>
//         </div>
//       </div>

//       {/* Grid */}
//       <div className="projects-section projects-page-wrapper">
//         <div className="projects-grid">
//           {filteredProjects.slice(0, visibleCount).map((project: any, index: number) => (
//             <div key={index} className="project-card">
//               <Link
//   to={`/projects/${project.slug}?loc=${locFilter}${typeFilter.length ? `&types=${typeFilter.join(",")}` : ""}`}
//   className="card-link"
// >
//                 <img
//                   src={`${process.env.PUBLIC_URL}${project.cover}`}
//                   alt={project.title}
//                   loading="lazy"
//                 />
//                 <h3>{project.title}</h3>
//               </Link>
//             </div>
//           ))}
//         </div>

//         {visibleCount < filteredProjects.length && (
//           <div className="button-wrapper">
//             <span className="line left-line"></span>
//             <button className="hero-button" onClick={handleLoadMore}>
//               LOAD MORE
//             </button>
//             <span className="line right-line"></span>
//           </div>
//         )}

//         {filteredProjects.length === 0 && (
//           <p className="text-center" style={{ marginTop: 24, opacity: 0.7 }}>
//             No projects match this filter.
//           </p>
//         )}
//       </div>

//       {/* Drawer */}
// <QuickFilterDrawer
//   open={drawerOpen}
//   onClose={() => setDrawerOpen(false)}
//   initialLocation={locFilter}
//   initialTypes={typeFilter}
//   allTypes={allTypes}
//   onApply={({ location, types }) => {
//     setLocFilter(location);
//     setTypeFilter(types);
//     setDrawerOpen(false);
//   }}
//   onClear={() => { setLocFilter("all"); setTypeFilter([]); }}
// />


//       <Footer />
//     </>
//   );
// };

// export default ProjectsPage;
// src/pages/ProjectsPage.tsx
import React, { useEffect, useMemo, useState } from "react";
import "./ProjectsPage.css";
import "../components/Projects.css";
import "../components/Hero.css";
import "../components/ButtonOverrides.css";
import Footer from "../components/Footer";
import { Link, useSearchParams } from "react-router-dom";
import { projects } from "../data/projects";

// ⬇️ Use ONLY QuickFilterDrawer (it exposes LocFilter)
import QuickFilterDrawer, { LocFilter } from "../components/QuickFilterDrawer";

// Import or define heroBg image
const heroBg = `${process.env.PUBLIC_URL}/images/Hero2.jpeg`;

// ==== helpers ====
const normalizeTypes = (t: any): string[] => (!t ? [] : Array.isArray(t) ? t : [t]);
const isInsideLebanon = (location?: string) =>
  typeof location === "string" && /(^|[\s,|.-])lebanon([\s,|.-]|$)/i.test(location);

const ProjectsPage: React.FC = () => {
  const [searchParams] = useSearchParams();

  // ---- initial filters from URL
  const initialLoc = (searchParams.get("loc") as LocFilter) || "all";
  const initialTypes = (searchParams.get("types") || "")
    .split(",")
    .filter(Boolean);
  const initialStatuses = (searchParams.get("statuses") || "")
    .split(",")
    .filter(Boolean);

  // ---- state
  const [locFilter, setLocFilter] = useState<LocFilter>(initialLoc);
  const [typeFilter, setTypeFilter] = useState<string[]>(initialTypes);
  const [statusFilter, setStatusFilter] = useState<string[]>(initialStatuses);

  const [drawerOpen, setDrawerOpen] = useState(false);

  // pagination
  const [visibleCount, setVisibleCount] = useState(9);

  // ---- distinct lists for drawer
  const allTypes = useMemo(() => {
    const all = projects.flatMap((p: any) => normalizeTypes(p.type));
    return Array.from(new Set(all)).sort((a, b) => a.localeCompare(b));
  }, []);

  const allStatuses = useMemo(() => {
    const s = new Set<string>();
    projects.forEach((p: any) => p.status && s.add(p.status));
    return Array.from(s).sort((a, b) => a.localeCompare(b));
  }, []);

  // ---- apply filters
  const filteredProjects = useMemo(() => {
    return projects.filter((p: any) => {
      // location
      if (locFilter === "inside" && !isInsideLebanon(p.location)) return false;
      if (locFilter === "outside" && isInsideLebanon(p.location)) return false;

      // type (OR)
      if (typeFilter.length) {
        const t = normalizeTypes(p.type).map((s) => s.toLowerCase());
        const typeHit = typeFilter.some((sel) => t.includes(sel.toLowerCase()));
        if (!typeHit) return false;
      }

      // status (OR)
      if (statusFilter.length) {
        if (!p.status || !statusFilter.includes(p.status)) return false;
      }

      return true;
    });
  }, [locFilter, typeFilter, statusFilter]);

  // reset pagination when filters change
  useEffect(() => setVisibleCount(9), [locFilter, typeFilter, statusFilter]);

  const handleLoadMore = () =>
    setVisibleCount((prev) => Math.min(prev + 9, filteredProjects.length));

  return (
    <>
      {/* Hero */}
      <div
        className="projects-hero"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="projects-hero-overlay">
          <p className="projects-tagline">WE STAND FOR</p>
          <h1 className="projects-title">Having an idea. Creating spaces.</h1>
        </div>
      </div>

      {/* Toolbar */}
      <div
        className="projects-toolbar"
        style={{
          maxWidth: 1280,
          margin: "16px auto 8px",
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "0 8px",
        }}
      >
        <button
          id="open-filter"
          onClick={() => setDrawerOpen(true)}
          style={{
            padding: "10px 16px",
            borderRadius: 10,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          ☰ Filter
        </button>

        <div style={{ opacity: 0.7 }}>
          Showing <b>{filteredProjects.length}</b> of <b>{projects.length}</b>
        </div>
      </div>

      {/* Grid */}
      <div className="projects-section projects-page-wrapper">
        <div className="projects-grid">
          {filteredProjects.slice(0, visibleCount).map((project: any, index: number) => (
            <div key={index} className="project-card">
              <Link
                to={`/projects/${project.slug}?loc=${locFilter}${
                  typeFilter.length ? `&types=${typeFilter.join(",")}` : ""
                }${statusFilter.length ? `&statuses=${statusFilter.join(",")}` : ""}`}
                className="card-link"
              >
                <img
                  src={`${process.env.PUBLIC_URL}${project.cover}`}
                  alt={project.title}
                  loading="lazy"
                />
                <h3>{project.title}</h3>
              </Link>
            </div>
          ))}
        </div>

        {visibleCount < filteredProjects.length && (
          <div className="button-wrapper">
            <span className="line left-line"></span>
            <button className="hero-button" onClick={handleLoadMore}>
              LOAD MORE
            </button>
            <span className="line right-line"></span>
          </div>
        )}

        {filteredProjects.length === 0 && (
          <p className="text-center" style={{ marginTop: 24, opacity: 0.7 }}>
            No projects match this filter.
          </p>
        )}
      </div>

      {/* Drawer — now with statuses wired */}
      <QuickFilterDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        initialLocation={locFilter}
        initialTypes={typeFilter}
        initialStatuses={statusFilter}
        allTypes={allTypes}
        allStatuses={allStatuses}
        onApply={({ location, types, statuses }) => {
          setLocFilter(location);
          setTypeFilter(types);
          setStatusFilter(statuses);
          setDrawerOpen(false);
        }}
        onClear={() => {
          setLocFilter("all");
          setTypeFilter([]);
          setStatusFilter([]);
        }}
      />

      <Footer />
    </>
  );
};

export default ProjectsPage;
